export default __webpack_public_path__ + "static/media/electrek-bike-charge-cafe.7b77525a.svg";